import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateShowWidenModal } from '../redux/reducers/widenSearchSlice';
import { Card, CardAction, CardHeader, CardBody, CardAsset, CardTimer, CardContent, CardBadge, CardTitle, CardSubtitle } from '@strapi/design-system/Card';
import Eye from '@strapi/icons/Eye';
import { IconButton } from '@strapi/design-system/IconButton';
import styles from './AssetCard.module.css';
import { ASSET_CARD_EYE_ICON_TOOLTIP_TEXT, ASSET_CARD_IMAGE_URL_BASE, ASSET_CARD_IMAGE_URL_PARAM, ASSET_CARD_INLINE_STYLE, FILE_TYPE } from '../utils/constants';
const AssetCard = ({
  item,
  onSelect,
  setModalVisible,
  setModalData
}) => {
  const filetype = item.file_properties.format_type;
  const previewFilename = item?.filename;
  const previewTitle = item?.metadata?.fields?.displayName[0];
  const previewUrl = item?.embeds?.original?.url;
  const duration = item?.file_properties?.video_properties?.duration;
  const timer = filetype === FILE_TYPE.video ? [parseInt(duration / 60 / 60), parseInt(duration / 60 % 60), parseInt(duration % 60)].join(':').replace(/\b(\d)\b/g, '0$1') : '';
  const cardAssetImageURL = `${ASSET_CARD_IMAGE_URL_BASE}${item.external_id}/jpeg/${item.filename}${ASSET_CARD_IMAGE_URL_PARAM}`;
  const dispatch = useDispatch();
  const {
    showWidenModal
  } = useSelector(state => state.widenSearch);
  const handlePreview = e => {
    e.stopPropagation();
    e.currentTarget.blur();
    setModalVisible(prev => !prev);
    setModalData({
      item,
      id: item.external_id,
      filetype: filetype,
      preview: previewUrl,
      title: previewTitle,
      fileName: previewFilename
    });
    dispatch(updateShowWidenModal(!showWidenModal));
  };
  return /*#__PURE__*/React.createElement(Card, {
    style: ASSET_CARD_INLINE_STYLE,
    onClick: () => onSelect(item)
  }, /*#__PURE__*/React.createElement(CardHeader, null, /*#__PURE__*/React.createElement(CardAction, {
    position: "end"
  }, /*#__PURE__*/React.createElement(IconButton, {
    label: ASSET_CARD_EYE_ICON_TOOLTIP_TEXT,
    icon: /*#__PURE__*/React.createElement(Eye, null),
    onClick: e => handlePreview(e, item.filename),
    "data-btn": "true"
  })), /*#__PURE__*/React.createElement(CardAsset, {
    className: styles['card-asset'],
    src: cardAssetImageURL
  }), filetype === FILE_TYPE.video && /*#__PURE__*/React.createElement(CardTimer, null, timer)), /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement(CardContent, {
    className: styles['card-content']
  }, /*#__PURE__*/React.createElement(CardTitle, {
    className: styles['card-title']
  }, item?.metadata?.fields?.displayName[0]), /*#__PURE__*/React.createElement(CardSubtitle, null, item.filename), /*#__PURE__*/React.createElement(CardBadge, {
    className: styles['card-badge']
  }, filetype))));
};
export default AssetCard;